<main class="domestica-page">
  <!-- HERO -->
  <section class="page-hero">
    <div class="container-xl pt-navfix">
      <div class="hero-card card-sami">
        <div class="row align-items-center g-4">
          <div class="col-12 col-lg-7">
            <h1 class="fw-bold mb-2">Pulizie domestiche a Pescara</h1>
            <p class="mb-0 hero-sub">
              Con <strong>SAMI Pulizie</strong> hai una casa pulita, ordinata e
              profumata. Interveniamo su
              <strong>cucine, bagni, camere, soggiorni</strong> e anche su
              <strong>finestre, serrande e balconi</strong> con prodotti
              professionali e personale qualificato.
              <strong>Sopralluogo gratuito</strong> e piano su misura.
            </p>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <button class="btn-sami" (click)="navigateToPreventiviSito()">
                Richiedi sopralluogo gratuito
              </button>
              <a class="btn-sami-outline" href="tel:08554360">Chiama 085 54360</a>
            </div>

            <div class="hero-chips mt-4">
              <div class="chip">
                <i class="fa-solid fa-house"></i> Casa sempre in ordine
              </div>
              <div class="chip">
                <i class="fa-solid fa-spray-can-sparkles"></i> Igienizzazione mirata
              </div>
              <div class="chip">
                <i class="fa-solid fa-wand-magic-sparkles"></i> Dettagli & rifiniture
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-5">
            <div class="hero-media">
              <img
                src="assets/pulizia-domestica.webp"
                class="hero-img"
                alt="Pulizie domestiche a Pescara: zona giorno e camere"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- (1) SEZIONE 2 COLONNE -->
  <section class="section">
    <div class="container-xl">
      <div class="row g-4 align-items-start">
        <!-- TESTO -->
        <div class="col-12 col-lg-7">
          <h2 class="fw-bold mb-3">Cosa offriamo</h2>

          <p class="text-muted mb-3">
            Le pulizie domestiche professionali ti aiutano a mantenere la casa
            sempre piacevole e igienizzata, senza stress e senza perdita di
            tempo. Possiamo lavorare con interventi <strong>regolari</strong>
            oppure <strong>occasionali</strong> (prima/dopo eventi, cambio
            stagione, trasloco).
          </p>

          <p class="text-muted mb-4">
            Usiamo prodotti adatti alle superfici, con attenzione a materiali
            delicati. Il servizio è personalizzabile: decidiamo insieme
            frequenza, priorità e aree da trattare.
          </p>

          <ul class="checklist">
            <li>
              <i class="fa-solid fa-check"></i> Pulizia camere, soggiorno e
              superfici (polvere, impronte, vetri)
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Cucina: piani, esterni
              elettrodomestici, piastrelle e punti critici
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Bagni: sanitari, rubinetteria,
              doccia e calcare
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Pavimenti: lavaggio e
              igienizzazione (gres, marmo, parquet)
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Finestre e serrande (su richiesta)
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Balconi e aree esterne (su richiesta)
            </li>
          </ul>
        </div>

        <!-- BOX AREE -->
        <div class="col-12 col-lg-5">
          <div class="card-sami p-4">
            <h3 class="fw-bold mb-3">Aree di intervento</h3>

            <ul class="bullets">
              <li>Camere da letto e soggiorni</li>
              <li>Cucine e piani di lavoro</li>
              <li>Bagni e sanitari</li>
              <li>Vetri, infissi e porte</li>
              <li>Serrande e tapparelle (su richiesta)</li>
              <li>Balconi e verande (su richiesta)</li>
              <li>Case vacanza e B&amp;B</li>
              <li>Interventi una tantum (prima/dopo eventi)</li>
            </ul>

            <div class="note-box mt-3">
              <strong>Nota:</strong> durante il sopralluogo definiamo priorità e
              frequenza per un servizio davvero su misura.
            </div>

            <div class="mini-cta mt-3">
              <div class="mini-cta-title">Vuoi una casa sempre perfetta?</div>
              <div class="mini-cta-text">
                Sopralluogo gratuito e preventivo chiaro.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- (2) COME FUNZIONA -->
  <section class="section section-soft">
    <div class="container-xl">
      <div class="process-wrap card-sami">
        <h2 class="text-center fw-bold mb-4">Come funziona</h2>

        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3">
          <div class="col">
            <div class="process-step">
              <div class="step-num">1</div>
              <div class="step-title">Sopralluogo</div>
              <div class="step-text">
                Valutiamo casa, superfici e priorità (bagni, cucina, vetri, ecc.).
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">2</div>
              <div class="step-title">Preventivo</div>
              <div class="step-text">
                Definiamo frequenza e attività, con un preventivo chiaro e personalizzato.
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">3</div>
              <div class="step-title">Intervento</div>
              <div class="step-text">
                Pulizia completa con prodotti professionali e attenzione ai dettagli.
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">4</div>
              <div class="step-title">Continuità</div>
              <div class="step-text">
                Programmi regolari o interventi spot, in base alle tue esigenze.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- (3) CTA BLU -->
  <section class="section-cta cta-wide">
    <div class="container-xl text-center">
      <h2 class="cta-title">La tua casa merita il meglio</h2>
      <p class="cta-text">
        Contattaci per un sopralluogo gratuito e un preventivo personalizzato senza impegno.
      </p>

      <div class="d-flex justify-content-center gap-2 flex-wrap mt-3">
        <button class="btn btn-light cta-btn" (click)="navigateToPreventiviSito()">
          Richiedi sopralluogo gratuito
        </button>
        <a class="btn btn-outline-light cta-btn" href="tel:08554360">
          Chiama ora
        </a>
      </div>
    </div>
  </section>

  <!-- MAPPA -->
  <section class="section">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="fw-bold">Dove operiamo</h2>
        <p class="text-muted mb-0">Sede commerciale: Via Tirino 145, Pescara.</p>
      </div>

      <div class="col-12 col-md-10 col-lg-8 mx-auto mt-3">
        <div class="ratio ratio-16x9 map-shell">
          <iframe
            loading="lazy"
            allowfullscreen
            style="border: 0"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2843.2073!2d14.2181475!3d42.4462893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1331a6223b8afae7%3A0xe0f8329b5888d54d!2sVia%20Tirino%2C%20145%2C%20Pescara!5e0!3m2!1sit!2sit!4v1713538014550"
          ></iframe>
        </div>
      </div>
    </div>
  </section>

  <!-- WhatsApp -->
  <div class="position-fixed bottom-0 end-0 mb-4 me-4" style="z-index: 1050">
    <a
      href="https://wa.me/3515034934"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatta su WhatsApp"
      class="btn btn-success rounded-circle btn-sm"
    >
      <i class="fa-brands fa-whatsapp fa-2x"></i>
    </a>
  </div>
</main>
